import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import ServicesGrid from "../components/ServicesGrid";
import EligibilitySimulator from "../components/EligibilitySimulator";
import WhyChooseUs, { ProcessTimeline } from "../components/WhyAndProcess";
import { Testimonials, FAQSection } from "../components/TestimonialsFAQ";
import { ArrowRight, Phone } from "lucide-react";
import { CONTACT, BLOG_POSTS, IMAGES } from "../data/content";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />

      {/* Trust bar */}
      <section className="bg-black/70 border-y border-white/5 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-3 text-white/50 text-xs uppercase tracking-[0.3em]">
          <span>RGE</span>
          <span className="text-[#7DD923]">·</span>
          <span>QualiPAC</span>
          <span className="text-[#7DD923]">·</span>
          <span>Qualibat</span>
          <span className="text-[#7DD923]">·</span>
          <span>MaPrimeRénov'</span>
          <span className="text-[#7DD923]">·</span>
          <span>Éco-Artisan</span>
        </div>
      </section>

      <ServicesGrid />

      {/* Simulator */}
      <section id="simulateur" className="relative section-padding bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="eyebrow">Simulateur d'éligibilité</div>
            <h2 className="font-display uppercase text-white text-4xl md:text-5xl lg:text-6xl mt-4 leading-[0.95] tracking-tight">
              Découvrez vos<br/>
              <span className="text-[#7DD923]">aides</span> en 2 min
            </h2>
            <p className="text-white/70 mt-6 leading-relaxed">
              Répondez à quelques questions et recevez instantanément une estimation des aides auxquelles vous avez droit : MaPrimeRénov', CEE, aides locales Alsace.
            </p>
            <ul className="mt-6 space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#7DD923]" /> 100% gratuit, sans engagement</li>
              <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#7DD923]" /> Réponse immédiate</li>
              <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-[#7DD923]" /> Rappel par un expert sous 24h</li>
            </ul>
          </div>
          <div className="lg:col-span-7">
            <EligibilitySimulator />
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <ProcessTimeline />
      <Testimonials />

      {/* Blog preview */}
      <section data-testid="blog-preview" className="section-padding bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-end justify-between gap-4 mb-12">
            <div>
              <div className="eyebrow">Conseils & guides</div>
              <h2 className="font-display uppercase text-white text-4xl md:text-5xl mt-4 leading-[0.95] tracking-tight">
                Le blog <span className="text-[#7DD923]">Optimeo</span>
              </h2>
            </div>
            <Link to="/blog" className="text-[#7DD923] hover:text-white text-sm font-semibold flex items-center gap-1">
              Tous les articles <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {BLOG_POSTS.slice(0,3).map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`blog-preview-${p.slug}`}
                className="group bg-[#121212] border border-white/5 rounded-2xl overflow-hidden hover:border-[#7DD923]/40 transition-colors"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-widest text-[#7DD923] font-bold">{p.category}</div>
                  <h3 className="font-display text-white text-xl mt-2 leading-tight tracking-tight group-hover:text-[#7DD923] transition-colors">{p.title}</h3>
                  <div className="text-white/40 text-xs mt-4 flex items-center justify-between">
                    <span>{p.date}</span><span>{p.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FAQSection />

      {/* CTA band */}
      <section className="relative section-padding overflow-hidden bg-black">
        <div className="absolute inset-0 opacity-30">
          <img src={IMAGES.house2} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black to-black/40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
          <div className="eyebrow">Prêt à démarrer ?</div>
          <h2 className="font-display uppercase text-white text-5xl md:text-7xl mt-4 leading-[0.9] tracking-tight">
            Économisez<br/><span className="text-[#7DD923]">dès aujourd'hui</span>
          </h2>
          <p className="text-white/70 mt-6 max-w-xl mx-auto">
            Étude gratuite, sans engagement, réponse sous 24h. Nos experts vous accompagnent de A à Z.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <Link to="/devis" data-testid="cta-band-devis" className="btn-primary">
              Étude gratuite <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={`tel:${CONTACT.phoneLink}`} data-testid="cta-band-call" className="btn-secondary">
              <Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
